/*
 * Copyright (C) 2026 - present Marek Kuzora - All Rights Reserved.
 */


import { use } from 'fierry/react';

import Galaxy from 'solis/application/galaxy';

import Route from 'solis/route';

import { PUBLIC_ROUTES } from 'solis/claude/layout/barrier';

import descriptor from 'solis/claude/action/descriptor/create.colony';

import Welcome from 'solis/claude/welcome';


export default ({ children }) =>
{
  const route = use(Route);

  const galaxy = use(Galaxy);

  if (PUBLIC_ROUTES.includes(route.getType()))
  {
    return children;
  }

  const account = galaxy.getCurrentAccount();

  if (descriptor.isAvailable({ account }))
  {
    return <Welcome account = {account} />;
  }

  return children;
};
